import {useTicketsFiltersContainer} from '../hooks/useTicketsFiltersContainer';
import {TicketsListViewAllFilters} from '../TicketsListToolbar/TicketsListViewAllFilters';
import {TicketsListViewDeptQueuesFilters} from '../TicketsListToolbar/TicketsListViewDeptQueuesFilters';

export const TicketsListViewFilters = () => {
  const {isAllTicketsView, deptQueues} = useTicketsFiltersContainer();
  if (deptQueues) {
    return <TicketsListViewDeptQueuesFilters />;
  }

  return <>{isAllTicketsView && <TicketsListViewAllFilters />}</>;
};
